// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"8e82f987","834":"d3ad7ef7","981":"e65fbd48"}[chunkId] + ".chunk.js";
};